"use strict";

import { showModal } from "../libs/@elements/cookie-permissions";

export function initInScope($scope) {
    $scope.find('.js-show-cookie-bar-modal').on('click', function (evt) {
        evt.preventDefault();
        showModal();
    });
}